// const addToCartButton = document.getElementById("add-to-cart-button");	
const stickyAddToCart = document.querySelector(".pdp-sticky-cart");	
const sectionToWatch = document.getElementById("shopify-section-footer");	

if (stickyAddToCart !== null) {
// Show the sticky Add to Cart button when scrolling down	
window.addEventListener("scroll", () => {	
    if (window.scrollY > 300) { // Adjust the scroll threshold as needed	
        // stickyAddToCart.style.display = "block";	
        stickyAddToCart.classList.add("active");	
    } else {	
        // stickyAddToCart.style.display = "none";	
        stickyAddToCart.classList.remove("active");	
    }	
});	
// Intersection Observer to remove class when section is in view	
const observer = new IntersectionObserver(entries => {	
    entries.forEach(entry => {	
        if (entry.isIntersecting) {	
            stickyAddToCart.classList.remove("active");	
        } else {	
            stickyAddToCart.classList.add("active");	
        }	
    });	
}, { threshold: 0.5 }); // Adjust the threshold as needed	
observer.observe(sectionToWatch);
}

let discount = document.querySelector('.component-apply-discount');
let discount_url_sel = document.querySelector('.component-apply-discount .discount-url');
if (discount_url_sel !== null) {
let discount_url = discount_url_sel.innerHTML;
}
let old_pdp_name = document.querySelector('.product-area__details__title').innerHTML;
let pdp_name = old_pdp_name.replace("&", "");

if (discount !== null) {
  discount.addEventListener('click',function(){
    window.history.pushState("", "", discount_url);
    discount.classList.add('applied');
  
    $.ajax({
    url: window.location.href,
    type: "GET",
    success: function(data) {
      // Reload the page with the updated content
      location.reload();
    },
    error: function(error) {
      // Handle any errors that occur during the AJAX request
      console.error("Error during AJAX request:", error);
    }
    });
    
    function setSessionCookie(name, value) {
    document.cookie = name + "=" + value + "; path=/";
    }
    // To set a session cookie
    setSessionCookie( pdp_name , pdp_name);
    
  });

}
function getSessionCookieValue(name) {
  const cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].trim();
    if (cookie.indexOf(name + "=") === 0) {
      return cookie.substring(name.length + 1, cookie.length);
    }
  }
    return null; // Return null if the session cookie is not found
  }
  
  // To retrieve the value of a session cookie
  const mySessionCookieValue = getSessionCookieValue(pdp_name);
  
  if (mySessionCookieValue == pdp_name ) {
    discount.classList.add('applied');
  }